import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestMovies() {
  const latestMovies = movies.slice(0, 8);

  return (
    <section className="py-12 md:py-16">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                最新推荐
              </h3>
              <p className="text-sm text-foreground-500 mt-1">精选高分好片，精彩不容错过</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latestMovies.map((movie) => (
              <Link
                key={movie.id}
                to={`/category/${movie.category}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3">
                  <img
                    src={movie.posterUrl}
                    alt={movie.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                  <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-bold flex items-center gap-1">
                    <i className="ri-star-fill text-[10px]"></i>
                    {movie.rating}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h4 className="text-sm md:text-base font-semibold text-foreground-50 truncate">
                      {movie.title}
                    </h4>
                    <p className="text-xs text-foreground-400 mt-0.5">{movie.year} / {movie.duration}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}